<template>
  <sidebar-menu
    :menu="menu"
    @toggle-collapse="onToggleCollapse"
    :collapsed="this.$vuetify.breakpoint.xsOnly ? false : collapsed"
    theme="white-theme"
    :width="menuWidth + 'px'"
  >
    <v-icon slot="dropdown-icon" style="display: none">{{
      $vuetify.icons.expand
    }}</v-icon>
    <template v-if="this.$vuetify.breakpoint.xsOnly" slot="toggle-icon">
      <v-icon>mdi-chevron-double-up</v-icon>
    </template>
    <template
      v-if="collapsed && !this.$vuetify.breakpoint.xsOnly"
      slot="toggle-icon"
    >
      <v-icon color="#eeeeee">mdi-chevron-double-right</v-icon>
    </template>
    <template
      v-if="!collapsed && !this.$vuetify.breakpoint.xsOnly"
      slot="toggle-icon"
    >
      <v-icon color="#eeeeee">mdi-chevron-double-left</v-icon>
    </template>
  </sidebar-menu>
</template>

<script>
import {
  isUserActive,
  hasPaymentOrderGenerateClaim,
  hasAdminClaim,
  hasSystemUserCreateClaim,
  hasSystemUserReviewClaim,
  hasUserReviewClaim,
  hasUserReviewAllClaim,
  hasUserUpdateClaim,
  hasUserCreateClaim,
  hasIssueReviewClaim,
  hasIssueUpdateClaim,
  hasSubsidyReportClaim
} from '@/router/auth.js'
import securityStore from '@/store/security-store'
import { SidebarMenu } from 'vue-sidebar-menu'

export default {
  components: {
    SidebarMenu
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false
    },
    menuWidth: {
      type: String,
      default: '300'
    }
  },
  methods: {
    onToggleCollapse (collapsed) {
      // this.collapsed = collapsed
      this.$emit('onCollapseClick', collapsed)
    }
  },
  computed: {
    isAuth () {
      return securityStore.getters.isAuth && isUserActive()
    },
    isAdmin () {
      return hasAdminClaim()
    },
    isUserTypeValid () {
      return securityStore.getters.userType === '0'
    },
    canReviewSystemUser () {
      return hasSystemUserReviewClaim()
    },
    canCreateSystemUser () {
      return hasSystemUserCreateClaim()
    },
    canReviewUser () {
      return hasUserReviewClaim()
    },
    canReviewAllUsers () {
      return hasUserReviewAllClaim()
    },
    canUpdateUser () {
      return hasUserUpdateClaim()
    },
    canCreateUser () {
      return hasUserCreateClaim()
    },
    canGeneratePaymentOrder () {
      return hasPaymentOrderGenerateClaim()
    },
    canReviewIssues () {
      return hasIssueReviewClaim()
    },
    canReviewIssue () {
      return hasIssueReviewClaim()
    },
    canUpdateIssue () {
      return hasIssueUpdateClaim()
    },
    canReportSubsidy () {
      return hasSubsidyReportClaim()
    },
    menu () {
      return [
        {
          title: this.$t('sidebar.dashboard'),
          href: { name: 'dashboard' },
          icon: {
            element: 'v-icon',
            text: 'dashboard',
            class: 'material-icons-outlined sidenav-icon'
          }
        },
        ...this.administrationMenu,
        ...this.subsidyMenu,
        ...this.paymentsMenu,
        ...this.reportsMenu,
        ...this.issuesMenu
      ]
    },
    administrationMenu () {
      const menuArray = [
        {
          title: this.$t('sidebar.administration'),
          icon: {
            element: 'v-icon',
            text: 'supervisor_account',
            class: 'material-icons-outlined sidenav-icon'
          },
          child: [
            ...this.systemUsersMenu,
            ...this.registerSystemUsersMenu,
            ...this.registerSystemUserMenu
          ]
        }
      ]
      return this.canReviewSystemUser || this.canCreateSystemUser
        ? menuArray
        : []
    },
    systemUsersMenu () {
      const menuArray = [
        {
          title: this.$t('sidebar.manageSystemUsers'),
          href: { name: 'manageSystemUsers' }
        }
      ]
      return this.canReviewSystemUser ? menuArray : []
    },
    registerSystemUsersMenu () {
      const menuArray = [
        {
          title: this.$t('sidebar.registerSystemUsers'),
          href: { name: 'registerSystemUsers' }
        }
      ]
      return this.canCreateSystemUser ? menuArray : []
    },
    registerSystemUserMenu () {
      const menuArray = [
        {
          title: this.$t('sidebar.registerSystemUser'),
          href: { name: 'registerSystemUser' }
        }
      ]
      return this.canCreateSystemUser ? menuArray : []
    },
    subsidyMenu () {
      const menuArray = [
        {
          title: this.$t('sidebar.subsidy'),
          icon: {
            element: 'v-icon',
            text: 'payment',
            class: 'material-icons-outlined sidenav-icon'
          },
          child: [
            ...this.usersMenu,
            ...this.reviewValidUserMenu,
            ...this.reviewUserMenu,
            ...this.reviewBeneficiaryMenu,
            ...this.reviewBeneficiariesMenu
          ]
        }
      ]
      return this.canRegisterUserPayment ||
        this.canReviewUser ||
        this.canReviewAllUsers ||
        this.canCreateUser ||
        this.canUpdateUser
        ? menuArray
        : []
    },
    usersMenu () {
      const menuArray = [
        {
          title: this.$t('sidebar.reviewUsers'),
          href: { name: 'reviewUsers' }
        }
      ]
      return this.canReviewAllUsers ? menuArray : []
    },
    reviewValidUserMenu () {
      const menuArray = [
        {
          title: this.$t('sidebar.updateUser'),
          href: { name: 'reviewValidUser' }
        }
      ]
      return this.canReviewUser ? menuArray : []
    },
    reviewBeneficiaryMenu () {
      const menuArray = [
        {
          title: this.$t('sidebar.reviewBeneficiary'),
          href: { name: 'reviewBeneficiary' }
        }
      ]
      return this.canReviewUser ? menuArray : []
    },
    reviewBeneficiariesMenu () {
      const menuArray = [
        {
          title: this.$t('sidebar.reviewBeneficiaries'),
          href: { name: 'reviewBeneficiaries' }
        }
      ]
      return this.canReviewUser ? menuArray : []
    },
    reviewUserMenu () {
      const menuArray = [
        {
          title: this.$t('sidebar.reviewUser'),
          href: { name: 'reviewUser' }
        }
      ]
      return this.canReviewUser ? menuArray : []
    },
    paymentsMenu () {
      const menuArray = [
        {
          title: this.$t('sidebar.payments'),
          icon: {
            element: 'v-icon',
            text: 'mdi-table',
            class: 'sidenav-icon'
          },
          child: [...this.generateOrderMenu]
        }
      ]
      return this.canGeneratePaymentOrder ? menuArray : []
    },
    generateOrderMenu () {
      const menuArray = [
        {
          title: this.$t('sidebar.generateOrders'),
          href: { name: 'generateOrders' }
        }
      ]
      return this.canGeneratePaymentOrder ? menuArray : []
    },
    issuesMenu () {
      const menuArray = [
        {
          title: this.$t('sidebar.issues'),
          icon: {
            element: 'v-icon',
            text: 'report_problem',
            class: 'material-icons-outlined sidenav-icon'
          },
          href: { name: 'reviewIssues' }
        }
      ]
      return this.canReviewIssue || this.canUpdateIssue ? menuArray : []
    },
    reportsMenu () {
      const menuArray = [
        {
          title: this.$t('sidebar.reports'),
          icon: {
            element: 'v-icon',
            text: 'insert_drive_file',
            class: 'material-icons-outlined sidenav-icon'
          },
          child: [...this.subsidyReport, ...this.issueReport]
        }
      ]
      return this.canReportSubsidy || this.canReviewIssue || this.canUpdateIssue ? menuArray : []
    },
    subsidyReport () {
      const menuArray = [
        {
          title: this.$t('sidebar.subsidyReport'),
          href: { name: 'subsidyReport' }
        }
      ]
      return this.canReportSubsidy ? menuArray : []
    },
    issueReport () {
      const menuArray = [
        {
          title: this.$t('sidebar.issueReport'),
          href: { name: 'issueReport' }
        }
      ]
      return this.canReviewIssue || this.canUpdateIssue ? menuArray : []
    }
  }
}
</script>
<style>
.v-sidebar-menu {
  margin-top: 40px;
  height: calc(100vh - 40px) !important;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.v-sidebar-menu .vsm--link {
  font-size: 15px !important;
  font-weight: 400 !important;
}

.vsm--dropdown {
  background-color: #354d5b !important;
  border-left: 4px solid #429a86;
}

.v-sidebar-menu .vsm--title {
  padding-left: 15px !important;
}

.vsm--dropdown .vsm--list {
  background-color: #354d5b !important;
}

.v-sidebar-menu.vsm_white-theme.vsm_expanded
  .vsm--item.vsm--item_open
  .vsm--link_level-1 {
  font-weight: 600 !important;
  color: #429a86 !important;
  background-color: #354d5b !important;
}

.v-sidebar-menu.vsm_white-theme.vsm_expanded
  .vsm--item.vsm--item_open
  .vsm--link_level-1:focus {
  outline: 1px solid #429a86 !important;
}

.v-sidebar-menu.vsm_white-theme.vsm_expanded
  .vsm--item.vsm--item_open
  .vsm--link_level-1
  > i {
  color: #429a86 !important;
  background-color: #354d5b !important;
}

.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_exact-active,
.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_active {
  box-shadow: 4px 0px 0px 0px #429a86 inset !important;
  color: #429a86 !important;
  background-color: #354d5b !important;
  outline: none !important;
}

.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_exact-active > i,
.v-sidebar-menu.vsm_white-theme .vsm--link_level-1.vsm--link_active > i {
  color: #429a86 !important;
  background-color: #354d5b !important;
}

.v-sidebar-menu.vsm_white-theme .vsm--link {
  color: #eeeeee !important;
}

.v-sidebar-menu.vsm_white-theme .vsm--dropdown .vsm--link {
  color: #eeeeee !important;
}

.v-sidebar-menu .vsm--link_exact-active,
.v-sidebar-menu .vsm--link_active {
  font-weight: 600 !important;
  color: #429a86 !important;
}

.v-sidebar-menu.vsm_white-theme .vsm--link:hover {
  color: #eeeeee !important;
  background-color: #455a64 !important;
}

.v-sidebar-menu.vsm_white-theme .vsm--link:hover > i {
  color: #eeeeee !important;
  background-color: #455a64 !important;
}

.v-sidebar-menu.vsm_white-theme.vsm_collapsed .vsm--mobile-bg {
  color: #eeeeee !important;
  background-color: #455a64 !important;
}

.v-sidebar-menu.vsm_white-theme.vsm_collapsed .vsm--link.vsm--link_mobile-item {
  color: #eeeeee !important;
  background-color: #455a64 !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.v-sidebar-menu.vsm_white-theme.vsm_collapsed
  .vsm--link.vsm--link_mobile-item
  .vsm--icon {
  color: #eeeeee !important;
  background-color: #455a64 !important;
}

.v-sidebar-menu.vsm_white-theme .vsm--icon {
  color: #eeeeee !important;
}

.v-sidebar-menu .vsm--dropdown > .vsm--list {
  padding-right: 0px !important;
  padding-left: 0px !important;
}

.v-sidebar-menu.vsm_collapsed > .vsm--list {
  width: 100% !important;
  padding-right: 0px !important;
}

.vsm--list {
  background-color: #283a47 !important;
}

.v-sidebar-menu.vsm_white-theme .vsm--toggle-btn {
  border-top: 1px solid #455a64;
  background-color: #283a47 !important;
}

.v-sidebar-menu.vsm_white-theme .vsm--link_level-1 .vsm--icon:hover {
  background-color: #455a64 !important;
}

.v-sidebar-menu.vsm_white-theme .vsm--toggle-btn:focus {
  outline: none !important;
}

.v-sidebar-menu.vsm_white-theme.vsm_collapsed
  .vsm--link.vsm--link_mobile-item
  .vsm--title {
  padding-left: 24px !important;
}

.sidenav-icon {
  background-color: #283a47 !important;
  color: #f5f5f5 !important;
}

.sidenav-badge {
  background-color: #ff8a80 !important;
  color: rgb(250, 250, 250) !important;
}
</style>
